module.exports = __webpack_public_path__ + "static/img/ABUIABAEGAAg0vvikQYo7d2q3QQwwAI4UA.f661c23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ABUIABAEGAAg0vvikQYo7d2q3QQwwAI4UA.png
// module id = Djz5
// module chunks = 1